// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"w2-z","colorTextValue":"x2-z","swatches":"y2-z","collapseLink":"z2-z","isCollapsed":"A2-z","dropdown":"B2-z","disabled":"C2-z"};